import styled from "styled-components";

export const Container = styled.div`
  background-color: white;
  width: ${({ cardWidth }) => (cardWidth ? `${cardWidth}px` : "269px")};
  display: flex;
  flex-direction: column;
  align-items: start;
  border-radius: 16px;
  z-index: 2;
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
  margin-top: 1rem;
  scale: ${(props) => props?.scale || "1"};
  margin-bottom: ${(props) => props?.marginBottom || "0px"};
`;

export const ContainerColor = styled.div`
  position: relative;
  width: ${({ cardWidth }) => (cardWidth ? `${cardWidth}px` : "269px")};
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-radius: 16px;
  background-color: #fff;
  overflow: hidden;
  padding: 16px 0;

  @media only screen and (min-width: 768px) {
    height: max-content;
  }
`;

export const LinkText = styled.div`
  font-size: 12px;
  font-family: Gilroy;
  color: #0397c9;
  display: flex;
  align-items: center;
  font-weight: bold;
  z-index: 2;
  column-gap: 4px;
  cursor: pointer;
`;

export const ContainerInner = styled.div`
  height: max-content;
  display: flex;
  border-radius: 16px;
  align-items: start;
  flex-direction: column;
  cursor: pointer;
  gap: 10px;
  overflow: hidden;
  padding: 2px;
  z-index: 100;
  position: relative;
  left: -2px;
`;

export const ContainerText = styled.div`
  display: flex;
  flex-direction: column;
  white-space: nowrap;
  margin-top: 8px;
  margin-left: 3px;
  width: 100%;

  @media only screen and (min-width: 768px) {
    position: relative;
    top: -8px;
  }
`;

export const LiveContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 50px;
  width: 100%;

  h1,
  span,
  h5,
  p {
    font-family: Gilroy;
  }

  h1 {
    margin: 0;
    padding: 0;
    font-size: 18px;
    font-weight: bold;
    font-family: Gilroy;
    line-height: unset;
  }

  span {
    margin: 0;
    padding: 0;
    font-size: 13px;
    color: #6a7481;
    font-weight: bold;
    line-height: unset;
  }

  h5 {
    margin: 0;
    padding: 0;
    font-size: 13px;
    color: #6a7481;
    line-height: unset;
    font-weight: normal;
  }

  p {
    display: flex;
    column-gap: 2px;
    margin: 0;
    padding: 0;
    font-size: 13px;
    color: #6a7481;
    line-height: unset;
    margin-top: 2px;
  }

  .event-place {
    padding: 0 16px;
  }
`;

export const LiveSection = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 16px;
`;

export const Title = styled.span`
  color: ${(props) => props.color || "#1F2D3D"};
  font-size: ${(props) => props.fontSize || "11px"};
  line-height: ${(props) => props.lineHeight || "13px"};
  font-weight: ${(props) => props.fontWeight || 700};
  text-overflow: ellipsis;
  overflow: hidden;
  display: block;
  word-break: break-all;
  width: 100%;
  padding: 0 16px;
`;

export const Header = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 0 16px;
  height: ${(props) => (props?.isRegistration ? "30px" : "60px")};
`;

export const LocationWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const LocationNameWrapper = styled.div`
  display: flex;
`;

export const ButtonWrapper = styled.div`
  padding: 0 16px;
  width: 100%;
`;

export const ButtonCard = styled.button`
  min-width: 100%;
  height: 36px;
  font-weight: bold;
  font-size: 14px;
  align-self: center;
  color: ${(props) => props.color || "#6A7481"};
  border: 1px solid #1f2d3d;
  border-radius: 24px;
  background-color: ${(props) =>
    props.backgroundColor || "rgba(106, 116, 129, 0)"};
  border-color: ${(props) => props.borderColor || "#6A7481"};

  @media screen and (max-height: 700px) {
    font-size: 14px;
  }

  @media only screen and (min-width: 768px) {
  }
`;

export const SwooshSVG = styled.img`
  position: absolute !important;
  top: 0 !important;
  right: 0 !important;
  z-index: 0 !important;
  object-fit: cover;
`;
